import type { ObjectMetadata } from '@olytic/foundation';

import { formatMonthYear, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDateTime, asLabel, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['resource-assignments'];
const hours = show((v) => `${formatNumber(v)}h`);

/** Hours of a role on a deal or project in a month. Rationale: resource-assignments.md. */
export const resourceAssignments: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Resource assignment',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('account_name', 'Account', { link: lookup('accounts', 'account_id') }),
    field('project_name', 'Project', { link: lookup('projects', 'project_id') }),
    field('opportunity_name', 'Opportunity', { link: lookup('opportunities', 'opportunity_id') }),
    field('resource_role_name', 'Role', { link: lookup('resource-roles', 'resource_role_id') }),
    field('app_user_name', 'Person', { link: lookup('people', 'app_user_id') }),
    field('month', 'Month', { format: show(formatMonthYear) }),
    field('hours', 'Hours', { format: hours }),
    field('status', 'Status', { format: asLabel }),
    field('source', 'Source', { format: asLabel }),
    field('edited_at', 'Edited', { format: asDateTime }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['account_name', 'project_name', 'opportunity_name', 'resource_role_name', 'app_user_name', 'month', 'hours', 'status'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['source', 'edited_at', 'created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'account_name', 'app_user_name', 'resource_role_name'],
};
